<template>
  <div class="mt-2 flex  overflow-hidden flex-grow ">
    <div class="overflow-hidden  flex flex-col pb-4 flex-grow bg-trader-gray mr-2 ">

      <!--go back  -->
      <div class="w-full  h-10 ">
        <CGoBack/>
      </div>

      <!--Bearbeitung Weißer hintergrund  -->
      <div class=" flex-grow overflow-hidden px-10 h-full  flex  flex-col justify-center ">
        <div class=" flex-grow overflow-hidden flex flex-col">


          <!--Formular Name -->
          <div class="flex flex-col">

            <div class="flex w-full    pb-6 ">
              <span class="text-xl w-[180px] ">Formular Name:</span>
              <input class=" border border-bg-trader-input-border border-header text-center w-[200px]"
                     v-model="name" data-ui="input-formular-name">
            </div>
            <div class="flex w-full pb-6 ">
              <span class="  w-[180px] text-xl ">Magazine Type:</span>
              <select class=" border border-bg-trader-input-border border-header  w-[200px] text-center"
                      v-model="magazineType"
                      data-ui="select-magazine-type">
                <option :value="0">kein type</option>
                <option v-for="magazineType in magazineTypes" :key="magazineType.magazineTypeId"
                        :value="magazineType.magazineTypeId">
                  {{ magazineType.magazineTypeTitle }}
                </option>
              </select>
            </div>

            <div class="flex justify-end w-full pb-2 ">
              <button class="p-2 w-[200px] bg-white " data-ui="toggleDraggable" @click="toggleDraggable">
                <!-- <i :class="{'fas fa-unlock': isDraggable, 'fas fa-lock': !isDraggable}"></i>-->
                {{ isDraggable ? 'Sortieren beenden' : 'Felder sortieren' }}
              </button>
            </div>
          </div>
          <Accordion :active="1" class="overflow-hidden w-full flex flex-col flex-grow">
            <!-- Seitenansicht Kopfzeile -->
            <AccordionSimpleItem title="Seitenansicht Kopfzeile" :flex="true" title-class="text-left w-full pl-2">
              <div class="overflow-auto  pt-4">

                <div class="flex justify-between items-center">
                  <div class="flex text-left h-10 bg-trader-darker-gray w-1/2" v-if="hasActiveFields">
                    <div v-for="(header, index) in headerData" :key="header.idProductFormHeader"
                         class="flex flex-col justify-center h-full text-center"
                         :class="[ header.size == 0  ? 'flex-grow': '']"
                         :style="{ width: header.size + 'px' }">
                      <div v-if="!header.deleted"
                           class="w-full h-full flex flex-col justify-center text-center">
                        <div class="text-white">
                          {{ header.label }}
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="flex-grow"></div>
                  <div class="">
                    <button class="p-2 w-[200px] bg-white mb-2" @click="createNewField('header')"
                            data-ui="create-field-page-view-header">Feld hinzufügen
                    </button>
                  </div>
                </div>

                <table class="w-full pt-4" v-if="hasActiveFields">
                  <thead class="uppercase">
                  <tr>
                    <th scope="col" class="px-1 text-left w-1/5">Bezeichnung</th>
                    <th scope="col" class="px-1 text-left  ">ProductFeld</th>
                    <th scope="col" class="px-1 text-left w-[150px]">größe</th>
                    <th scope="col" class="px-1 text-left w-[40px]">Action</th>
                  </tr>
                  </thead>
                  <draggable class="w-full " tag="tbody" :animation="200" v-model="headerData" :disabled="!isDraggable">
                    <template v-for="(header, index) in headerData">

                      <tr v-if="header.deleted !== true" class=" hover:bg-trader-blue w-full ">

                        <td class="px-1 align-top p-2">
                          <input :data-ui="'description-' + index" class="outline-0 border border-bg-trader-input-border border-header text-black p-1 w-full  shadow-inner-2 "
                            v-model="header.label" :class="isDraggable ? 'cursor-grab' : 'cursor-text'">
                        </td>
                        <td>
                          <select v-model="header.field" :data-ui="'selected-fields-' + index"
                                  class="cursor-grab outline-0 border border-bg-trader-input-border border-header text-black p-1 w-full  shadow-inner-2 ">
                            <option :value="productCustomField.fieldName" v-for="productCustomField in productCustomFields"
                                    :key="productCustomField.idProductCustomField">
                              {{ productCustomField.fieldName }}
                            </option>
                          </select>
                        </td>
                        <td class="text-center ">
                          <div class="w-full flex">
                            <input type="number" min="0" max="500" :data-ui="'size-' + index"
                                   :class="isDraggable ? 'cursor-grab' : 'cursor-text'"
                                   class=" outline-0 border border-bg-trader-input-border border-header text-black p-1 w-full  shadow-inner-2 "
                                   placeholder="Pixel angaben ..." v-model="header.size">
                            <div class="flex flex-col  justify-center items-center  bg-primary ml-1">
                              <div
                                  class="hover:bg-trader-blue hover:text-white w-full h-1/2 flex items-center justify-center"
                                  @click="increasePixelValue('header', header.idProductFormHeader)">
                                <i class="fa-solid fa-sort-up"></i>
                              </div>
                              <div
                                  class="hover:bg-trader-blue hover:text-white w-full h-1/2 flex items-center justify-center"
                                  @click="decreasePixelValue('header', header.idProductFormHeader)">
                                <i class="fa-solid fa-sort-down"></i>
                              </div>
                            </div>

                          </div>
                        </td>

                        <td class="px-1 text-center p-2">
                          <i class="fas fa-times p-2 hover:text-white w-full" @click="deleteField(index, 'header')"
                             data-ui="icon-delete-page-view-header"></i>
                        </td>
                      </tr>
                    </template>
                  </draggable>

                </table>

              </div>
            </AccordionSimpleItem>
            <!-- Seitenansicht Formular -->
            <AccordionSimpleItem title="Seitenansicht Formular " :flex="true" title-class="text-left w-full pl-2  ">

              <div class=" h-full flex flex-col ">
                <div class="flex items-center w-full py-2 sticky top-0 bg-primary ">
                  <div class="flex-grow"></div>
                  <button class="p-2 w-[200px] bg-white  pb-2" @click="createNewField('formular')"
                          data-ui="create-field-page-view-formular">Feld hinzufügen
                  </button>
                </div>
                <table class="w-full  " v-if="formularData.some(field => !field.deleted)">
                  <thead class="uppercase ">
                  <tr>
                    <th scope="col" class="px-1 text-left w-1/5">Bezeichnung</th>
                    <th scope="col" class="px-1 text-left  ">Vorschau</th>
                    <th scope="col" class="px-1 text-left  w-1/5">Type</th>
                    <th scope="col" class="px-1 text-left w-1/5">Produktfeld</th>
                    <th scope="col" class="px-1 text-left"></th>
                    <th scope="col" class="px-1 text-left"></th>
                    <th scope="col" class="px-1 text-left"></th>
                  </tr>
                  </thead>

                  <draggable class=" w-full  overflow-auto  " tag="tbody" :animation="200" v-model="formularData"
                             :disabled="!isDraggable">
                    <template v-for="(field, index) in formularData" >
                      <tr v-if="field.deleted !== true" :data-ui="'move-field-' + index"
                          :class="[ 'hover:bg-trader-blue', 'w-full', field.id === 0 ? 'bg-red-500' : '']">
                        <td class="px-1 align-top p-2">
                          <input :data-ui="'side-description-' + index"
                                 class="outline-0 border border-bg-trader-input-border border-header text-black p-1 w-full  shadow-inner-2 "
                                 :class="isDraggable ? 'cursor-grab' : 'cursor-text'"
                                 v-model="field.label">
                        </td>
                        <td class="px-1 align-top p-2">
                          <div v-if="field.formularType === 'group'" class="bg-trader-darkest-gray  p-1 text-black">
                            {{ field.label }}
                          </div>
                          <input v-if="field.formularType === 'input'" :readonly="true"
                                 :class="{'bg-trader-gray': field.readOnly ? isDraggable ? 'cursor-grab' : 'cursor-text': ''}"
                                 class="cursor-grab outline-0 border border-bg-trader-input-border border-header p-1 w-full shadow-inner-2">
                          <input v-if="field.formularType === 'checkbox'"
                                 @change="(e) => { e.preventDefault(); e.target.checked = false;}" :value="false"
                                 :disabled="field.readOnly" :readonly="true" type="checkbox"
                                 class="cursor-grab outline-0 border border-bg-trader-input-border border-header p-1 ">
                          <textarea v-if="field.formularType === 'textarea'" :readonly="true"
                                    :class="{'bg-trader-gray': field.readOnly ? isDraggable ? 'cursor-grab' : 'cursor-text': ''}"
                                    class="cursor-grab outline-0 border border-bg-trader-input-border border-header p-1 w-full  shadow-inner-2 "></textarea>

                          <template v-for="customization in customizations.fieldTypes">
                            <component v-if="field.formularType === customization.key" :is="customization.component"
                                       :form-field="field"
                                       :product-data="null"
                                       :class="isDraggable ? 'cursor-grab' : 'cursor-text'"
                                       :on-change-product-field-value="() =>{}" :get-field-value="() => {}"></component>
                          </template>
                        </td>
                        <td class="px-1 align-top p-2">
                          <select
                              class="cursor-grab outline-0 border border-bg-trader-input-border border-header p-1 w-full  shadow-inner-2 text-black"
                              v-model="field.formularType" :data-ui="'field-type-' + index">
                            <option value="input">Einzeiliger Text</option>
                            <option value="textarea">Mehrzeiliger Text</option>
                            <option value="checkbox">Checkbox</option>
                            <option value="group">Gruppe</option>

                            <option v-for="customization in customizations.fieldTypes" :value="customization.key">
                              {{ customization.name }}
                            </option>
                          </select>
                        </td>

                        <td class="px-1 align-top p-2">
                          <select v-model="field.field"
                                  class="cursor-grab outline-0 border border-bg-trader-input-border border-header p-1 w-full  shadow-inner-2 text-black"
                                  :data-ui="'select-product-field-type-'+ index ">
                            <option :value="productCustomField.fieldName" v-for="productCustomField in productCustomFields"
                                    :key="productCustomField.idProductCustomField">
                              {{ productCustomField.fieldName }}
                            </option>
                          </select>
                        </td>

                        <td class="text-center">
                          <template v-for="customization in customizations.fieldTypes">
                            <button v-if="field.formularType === customization.key && customization?.component?.meta?.hasOptions" class="bg-white text-trader-darkest-gray hover:text-trader-blue hover:bg-white cursor-pointer">
                              <i class="fas fa-gear p-2 " @click="openOptionsDialog(index)"></i>
                            </button>
                          </template>
                        </td>

                        <td class="px-1 text-center">
                          <input type="checkbox"
                                 class="border border-bg-trader-input-border border-header  text-black"
                                 v-model="field.readOnly" :data-ui="'only-read-checkbox' + index">
                        </td>

                        <td class="px-1 text-center">
                          <i class="fas fa-times p-2 hover:text-white" @click="deleteField(index, 'formular')" data-ui="icon-delete-page-view"></i>
                        </td>

                      </tr>
                    </template>
                  </draggable>

                </table>
              </div>

            </AccordionSimpleItem>
            <!-- Listenansicht Kopfzeile -->
            <AccordionSimpleItem title="Listenansicht Kopfzeile" :flex="true" title-class="text-left w-full pl-2">
              <div class="overflow-auto h-full pt-4">
                <div class="flex">
                  <div class="flex text-left h-10  bg-trader-darker-gray w-1/2"
                       v-if="listData && listData.some(field => !field.deleted)">
                    <div v-for="(list, index) in listData" :key="list.idProductFormList"
                         class="flex flex-col justify-center h-full text-center"
                         :class="[ list.size == 0  ? 'flex-grow': '']"
                         :style="{ width: list.size + 'px' }">
                      <div v-if="!list.deleted"
                           class="w-full h-full flex flex-col justify-center text-center">
                        <div class="text-white">
                          {{ list.label }}
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="flex-grow"></div>
                  <div class=" h-full">
                    <button class="p-2 w-[200px] bg-white mb-2" @click="createNewField('list')"
                            data-ui="create-field-list-view-header">Feld hinzufügen
                    </button>
                  </div>
                </div>
                <table class="w-full pt-4" v-if="listData.some(field => !field.deleted)">
                  <thead class="uppercase">
                  <tr>
                    <th scope="col" class="px-1 text-left w-1/5">Bezeichnung</th>
                    <th scope="col" class="px-1 text-left  ">ProductFeld</th>
                    <th scope="col" class="px-1 text-left w-[150px]">größe</th>
                    <th scope="col" class="px-1 text-left w-[150px]">Type</th>
                    <th scope="col" class="px-1 text-left w-[40px]">Action</th>
                  </tr>
                  </thead>
                  <draggable class="w-full " tag="tbody" :animation="200" v-model="listData" :disabled="!isDraggable">
                    <template v-for="(list, index) in listData">

                      <tr v-if="list.deleted !== true" class=" hover:bg-trader-blue w-full ">

                        <td class="px-1 align-top p-2"><input :data-ui="'list-header-description-' + index"
                            class="cursor-grab outline-0 border border-bg-trader-input-border border-header text-black p-1 w-full  shadow-inner-2 "
                            v-model="list.label" :class="isDraggable ? 'cursor-grab' : 'cursor-text'">
                        </td>
                        <td>
                          <select v-model="list.field" :data-ui="'list-header-field-' + index"
                                  :class="isDraggable ? 'cursor-grab' : 'cursor-text'"
                                  class=" outline-0 border border-bg-trader-input-border border-header text-black p-1 w-full  shadow-inner-2 ">
                            <option v-for="productCustomField in productCustomFields"
                                    :key="productCustomField.idProductCustomField">
                              {{ productCustomField.fieldName }}
                            </option>
                          </select>
                        </td>
                        <td class="text-center ">
                          <div class="w-full flex">
                            <input type="number" min="0" max="500"  :data-ui="'list-header-size-' + index"
                                   class=" outline-0 border border-bg-trader-input-border border-header text-black p-1 w-full  shadow-inner-2 "
                                   :class="isDraggable ? 'cursor-grab' : 'cursor-text'"
                                   placeholder="Pixel angaben ..." v-model="list.size">
                            <div class="flex flex-col  justify-center items-center  bg-primary ml-1">
                              <div
                                  class="hover:bg-trader-blue hover:text-white w-full h-1/2 flex items-center justify-center"
                                  @click="increasePixelValue('list', list.idProductFormList)">
                                <i class="fa-solid fa-sort-up"></i>
                              </div>
                              <div
                                  class="hover:bg-trader-blue hover:text-white w-full h-1/2 flex items-center justify-center"
                                  @click="decreasePixelValue('list', list.idProductFormList)">
                                <i class="fa-solid fa-sort-down"></i>
                              </div>
                            </div>

                          </div>
                        </td>
                        <td>
                          <select
                              class="cursor-grab outline-0 border border-bg-trader-input-border border-header p-1 w-full  shadow-inner-2 text-black"
                              :class="isDraggable ? 'cursor-grab' : 'cursor-text'" :data-ui="'field-type-list-' + index"
                              v-model="list.type">
                            <option value="input">Einzeiliger Text</option>
                            <option value="text">Text</option>
                            <option value="textarea">Mehrzeiliger Text</option>
                            <option value="checkbox">Checkbox</option>
                            <option value="group">Gruppe</option>

                            <option v-for="customization in customizations.fieldTypes" :value="customization.key">
                              {{ customization.name }}
                            </option>
                          </select>
                        </td>

                        <td class="px-1 text-center p-2">
                          <i class="fas fa-times p-2 hover:text-white w-full" @click="deleteField(index, 'list')"
                             data-ui="icon-delete-list-view-header"></i>
                        </td>
                      </tr>
                    </template>
                  </draggable>

                </table>

              </div>
            </AccordionSimpleItem>
            <!-- Listenansicht Formular -->
            <AccordionSimpleItem title="Listenansicht Formular" :flex="true" title-class="text-left w-full pl-2">
              <div class="overflow-auto h-full pt-4">

                <div class="flex ">
                  <div class="flex  text-left   overflow-auto bg-white ">

                    <div class="border-l p-1" :style="{ width: listMarketMainSize+ 'px' }">

                      <div class="flex mt-1">
                        <span class=" text-trader-xs w-[150px]">Belegt:</span>
                        <input class="" type="checkbox">
                      </div>
                      <div v-for="(listMarket, index) in listMarketData" :key="listMarket.idProductFormListMarket">

                        <div class="flex" v-if="listMarket.type ==='input' ">
                          <span class="flex-shrink-0 mr-1">{{ listMarket.label }}</span>
                          <input
                              class="cursor-grab  border border-bg-trader-input-border border-header text-center  w-full   ">

                        </div>
                        <div class="flex-shrink-0 " v-if="listMarket.type ==='checkbox' ">
                          <span :style="{ width: listMarket.textSize + 'px' }" class="">{{ listMarket.label }}</span>
                          <input class="  order border-bg-trader-input-border border-header w-full" type="checkbox">

                        </div>
                        <div v-if="listMarket.type === 'textarea'" class="flex">
                          <span class="text-trader-xs flex-shrink-0"
                                :style="{ width: listMarket.textSize + 'px' }">{{ listMarket.label }}</span>
                          <textarea class="  border border-bg-trader-input-border border-header w-full">
                       </textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="flex  ">
                      <div class="flex w-full     ">
                        <span class=" w-[100px] h-8 p-1 ">Gesamt Breite:</span>
                        <input type="number" min="0" max="500" data-ui="list-market-main-size"
                               class="text-xl border border-bg-trader-input-border border-header text-center w-[200px] h-8"
                               v-model="listMarketMainSize">
                      </div>
                      <div class="flex flex-col  justify-center items-center w-6 bg-primary h-full p-1">

                        <div
                            class="hover:bg-trader-blue hover:text-white w-full h-1/2 flex items-center justify-center"
                            @click="increasePixelValue('listMarket')">
                          <i class="fa-solid fa-sort-up"></i>
                        </div>
                        <div
                            class="hover:bg-trader-blue hover:text-white w-full h-1/2 flex items-center justify-center"
                            @click="decreasePixelValue('listMarket')">
                          <i class="fa-solid fa-sort-down"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="flex-grow"></div>
                  <div class="flex justify-end">

                    <div class="flex-shrink-0">
                      <button class="p-2 w-[200px] bg-white mb-2" @click="createNewField('listMarket')"
                              data-ui="create-field-list-view-formular">Feld hinzufügen
                      </button>
                    </div>
                  </div>
                </div>
                <table class="w-full pt-4" v-if="listMarketData && listMarketData.some(field => !field.deleted)">
                  <thead class="uppercase">
                  <tr>
                    <th scope="col" class="px-1 text-left w-1/5">Bezeichnung</th>
                    <th scope="col" class="px-1 text-left  ">ProductFeld</th>
                    <th scope="col" class="px-1 text-left w-[150px]">Type</th>
                    <th scope="col" class="px-1 text-left w-[40px]">Action</th>
                  </tr>
                  </thead>
                  <draggable class="w-full " tag="tbody" :animation="200" v-model="listMarketData"
                             :disabled="!isDraggable">
                    <template v-for="(listMarket, index) in listMarketData">

                      <tr v-if="listMarket.deleted !== true" class=" hover:bg-trader-blue w-full ">

                        <td class="px-1 align-top p-2"><input :data-ui="'list-market-label-' + index"
                            class=" outline-0 border border-bg-trader-input-border border-header text-black p-1 w-full  shadow-inner-2 "
                            v-model="listMarket.label" :class="isDraggable ? 'cursor-grab' : 'cursor-text'">
                        </td>
                        <td>
                          <select v-model="listMarket.field" :class="isDraggable ? 'cursor-grab' : 'cursor-text'" :data-ui="'list-market-field-' + index"
                                  class=" outline-0 border border-bg-trader-input-border border-header text-black p-1 w-full  shadow-inner-2 ">
                            <option v-for="productCustomField in productCustomFields"
                                    :key="productCustomField.idProductCustomField">
                              {{ productCustomField.fieldName }}
                            </option>
                          </select>
                        </td>
                        <td>
                          <select
                              class=" outline-0 border border-bg-trader-input-border border-header p-1 w-full  shadow-inner-2 text-black"
                              v-model="listMarket.type" :data-ui="'list-market-type-' + index"
                              :class="isDraggable ? 'cursor-grab' : 'cursor-text'">
                            <option value="input">Einzeiliger Text</option>
                            <option value="textarea">Mehrzeiliger Text</option>
                            <option value="checkbox">Checkbox</option>
                            <option value="group">Gruppe</option>

                            <option v-for="customization in customizations.fieldTypes" :value="customization.key">
                              {{ customization.name }}
                            </option>
                          </select>
                        </td>

                        <td class="px-1 text-center p-2">
                          <i class="fas fa-times p-2 hover:text-white w-full"
                             @click="deleteField(index, 'listMarket')" data-ui="icon-delete-list-view"></i>
                        </td>
                      </tr>
                    </template>
                  </draggable>

                </table>

              </div>
            </AccordionSimpleItem>
          </Accordion>
        </div>

        <div class="flex">
          <div class="w-full">
            <button class="p-2 bg-trader-red w-[200px]" @click="deleteTrue()" data-ui="button-delete-formular">Formular
              Löschen
            </button>
          </div>

          <div>
            <button class="p-2 bg-trader-green w-[200px]" @click="saveFormField" data-ui="button-save-formular-changes">
              Speichern
            </button>
          </div>
          <!-- feld Hinzufpgen button -->
        </div>
      </div>
    </div>

    <Sidebar/>
  </div>

</template>


<script>
import Sidebar from "@/components/Administration/Sidebar.vue";
import router from "@/router";
import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";
import {VueDraggableNext} from "vue-draggable-next";
import {eventBus} from "@/application/EventBus";
import SignalBus from "@/application/SignalBus";
import {customizations} from "@/customizations/customizations";
import AccordionItem from "@/components/Accordion/AccordionItem.vue";
import Accordion from "@/components/Accordion/Accordion.vue";
import AccordionSimpleItem from "@/components/Accordion/AccordionSimpleItem.vue";
import SuccessConfirmation from "@/components/Dialogs/SuccessConfirmation.vue";
import CGoBack from "@/components/Administration/CGoBack.vue";

export default {
  components: {CGoBack, AccordionSimpleItem, Accordion, AccordionItem, Sidebar, draggable: VueDraggableNext, SignalBus},

  data() {
    return {
      listMarketData: [],
      startValue: 123,
      getPosition: [],
      formFieldId: 0,
      formularDataGroup: null,
      formularData: [],
      lapel: "",
      listMarketType: "",
      type: "",
      readOnly: false,
      fieldName: "",
      delete: false,
      productCustomFields: [],
      headers: [],
      lists: [],
      headerProductField: '',
      listProductField: '',
      listMarketProductField: '',
      size: '',
      headerLabel: '',
      listLabel: '',
      listMarketLabel: '',
      listMarketMainSize: '',
      headerData: [],
      listData: [],
      magazineType: 0,
      magazines: [],
      magazineTypes: [],
      formularName: [],
      name: '',
      accordionIndex: 0,
      isDraggable: false,
    }
  },
  computed: {
    customizations() {
      return customizations
    },
    hasActiveFields() {
      return this.headerData.some(header => !header.deleted);
    },
  },
  methods: {
    openOptionsDialog(index) {
      let hasOptions = false;

      customizations.fieldTypes.forEach((item) => {
        if (item.key === this.formularData[index].formularType) {
          

          if(item?.component?.meta?.hasOptions) {
            hasOptions = true;
            const value = this.formularData[index].value;

            item.component.showOptions(value, (value) => {
              this.formularData[index].value = value;
              
            });
          }
        }
      })

      if (!hasOptions) {
        eventBus.openModal(SuccessConfirmation, {
          title: "Keine Optionen",
          message: "Dieses Formularfeld hat keine weiteren Optionen",
        });
      }

    },
    toggleDraggable() {
      this.isDraggable = !this.isDraggable; // Umschalten des Zustands
    },
    copyToClipboard(value) {
      const el = document.createElement('textarea');
      el.value = value;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);

    },
    async getFormularName() {
      try {
        const response = await apolloClient.query({
          query: gql`
        query getFormularName($productFormId: Int!) {
          getFormularName(productFormId: $productFormId) {
            idForm
            name
            magazineType
          }
        }
      `,
          variables: {
            productFormId: this.formFieldId
          }
        });

        // Extrahiere die Daten aus der Antwort
        this.formularName = response.data.getFormularName;
        for (let i = 0; i < this.formularName.length; i++) {
          this.name = this.formularName[i].name;
          this.magazineType = this.formularName[i].magazineType;
        }


      } catch (error) {
        console.error("Fehler beim Abrufen der formularName:", error);
      }
    },
    async getMagazineTypes() {
      try {
        const response = await apolloClient.query({
          query: gql`
            query getMagazineTypes {
              getMagazineTypes {
                magazineTypeId
                magazineType
                magazineTypeTitle

              }
            }
          `
        });

        this.magazineTypes = response.data.getMagazineTypes;

      } catch (error) {
        console.error("Fehler beim Abrufen der magazineTypes:", error);
      }
    },
    deleteTrue() {
      eventBus.openConfirm({
        title: "Formular",
        message: "Möchten Sie dieses Formular wirklich löschen?",
        onAccept: () => {
          this.deleteFormular();
        }
      });
    },
    increasePixelValue(type, id) {
      let size = 0
      if (type === 'list') {
        this.listData.forEach((item) => {
          if (item.idProductFormList === id) {
            size = parseInt(item.size);
            size++;
            item.size = size.toString();
          }
        })
      } else if (type === 'listMarket') {
        size = parseInt(this.listMarketMainSize);
        size++;
        this.listMarketMainSize = size.toString();
      } else if (type === 'header') {

        this.headerData.forEach((item) => {
          if (item.idProductFormHeader === id) {
            size = parseInt(item.size);
            size++;
            item.size = size.toString();
          }
        })
      }

    },
    decreasePixelValue(type, id) {
      let size = 0
      if (type === 'list') {
        this.listData.forEach((item) => {
          if (item.idProductFormList === id) {
            size = parseInt(item.size);
            size--;
            if (size < 0) {
              size = 0;
            }
            item.size = size.toString();
          }
        })
      } else if (type === 'listMarket') {
        let size = parseInt(this.listMarketMainSize);
        size--;
        if (size < 0) {
          size = 0;
        }
        this.listMarketMainSize = size.toString();
      } else if (type === 'header') {
        this.headerData.forEach((item) => {
          if (item.idProductFormHeader === id) {
            size = parseInt(item.size);
            size--;
            if (size < 0) {
              size = 0;
            }
            item.size = size.toString();
          }
        })
      }
    },

    async getProductCustomFields() {
      try {
        const response = await apolloClient.query({
          query: gql`
            query getProductCustomFields {
              getProductCustomFields {
                idProductCustomField
                fieldName

              }
            }
          `
        });

        this.productCustomFields = response.data.getProductCustomFields;

      } catch (error) {
        console.error("Fehler beim Abrufen der getFormField:", error);
      }
    },

    async getProductFormListMarket() {
      try {
        const response = await apolloClient.query({
          query: gql`
            query  getProductFormListMarket($idProductForm: Int!) {
              getProductFormListMarket(idProductForm: $idProductForm) {
                idProductFormListMarket
                idProductForm
                label
                field
                mainSize
                textSize
                type
              }
            }
          `,
          variables: {
            idProductForm: this.formFieldId
          }
        });

        try {
          let data = response.data.getProductFormListMarket;
          

          
          if (data === null) {
            this.listMarketData = [];
          } else {
            data.forEach((item) => {
              item.deleted = false;
            })
            this.listMarketData = data;
            this.listMarketMainSize = data[0]?.mainSize || 0;
          }

          
        } catch (error) {
          console.error(error);
        }

      } catch (error) {
        console.error("Fehler beim Abrufen der getProductFormHeader:", error);
      }
    },
    async getProductFormList() {
      try {
        const response = await apolloClient.query({
          query: gql`
            query  getProductFormList($idProductForm: Int!) {
              getProductFormList(idProductForm: $idProductForm) {
                idProductFormList
                idProductForm
                label
                field
                size
                type
              }
            }
          `,
          variables: {
            idProductForm: this.formFieldId
          }
        });

        try {
          let data = response.data.getProductFormList;
          if (data === null) {
            this.listData = [];
          } else {
            data.forEach((item) => {
              item.deleted = false;
            })
            this.listData = data;
          }
        } catch (error) {
          console.error(error);
        }

      } catch (error) {
        console.error("Fehler beim Abrufen der getProductFormHeader:", error);
      }
    },
    async getProductFormHeader() {
      try {
        const response = await apolloClient.query({
          query: gql`
            query  getProductFormHeader($idProductForm: Int!) {
              getProductFormHeader(idProductForm: $idProductForm) {
                idProductFormHeader
                idProductForm
                label
                field
                size
              }
            }
          `,
          variables: {
            idProductForm: this.formFieldId
          }
        });

        try {
          let data = response.data.getProductFormHeader;
          if (data === null) {
            this.headerData = [];
          } else {
            data.forEach((item) => {
              item.deleted = false;
            })
            this.headerData = data;
          }

          

        } catch (error) {
          console.error(error);
        }

      } catch (error) {
        console.error("Fehler beim Abrufen der getProductFormHeader:", error);
      }
    },

    createFormHeader() {

      this.headerData.push({
        idProductFormHeader: 0,
        idProductForm: this.formFieldId,
        label: 'Neues Feld',
        field: '',
        size: '100',
        deleted: false,
        position: this.headerData.length + 1,
      })
    },

    createFormListMarket() {
      this.listMarketData.push({
        idProductFormListMarket: 0,
        idProductForm: this.formFieldId,
        label: 'Neues Feld',
        field: '',
        size: '100',
        deleted: false,
        position: this.listMarketData.length + 1,
        listMarketType: 'text'
      })
    },
    createFormList() {

      this.listData.push({
        idProductFormList: 0,
        idProductForm: this.formFieldId,
        label: 'Neues Feld',
        field: '',
        size: '100',
        deleted: false,
        position: this.listData.length + 1,
        type: 'text'
      })
    },
    editHeader() {
      let data = [];
      this.headerData.forEach((header, index) => {

        //baue formular elemente zum speichern auf
        data.push({
          idProductFormHeader: header.idProductFormHeader,
          idProductForm: this.formFieldId,
          label: header.label,
          field: header.field,
          size: header.size,
          deleted: header.deleted,
          position: index + 1,
        })

      })
      this.headerData = data;
    },
    editList() {
      let data = [];
      this.listData.forEach((list, index) => {
        data.push({
          idProductFormList: list.idProductFormList,
          idProductForm: this.formFieldId,
          label: list.label,
          field: list.field,
          size: list.size,
          deleted: list.deleted,
          position: index + 1,
          type: list.type
        })

      })
      this.listData = data;
    },
    editListMarket() {
      let data = [];
      this.listMarketData.forEach((list, index) => {
        data.push({
          idProductFormListMarket: list.idProductFormListMarket,
          idProductForm: this.formFieldId,
          label: list.label,
          field: list.field,
          mainSize: this.listMarketMainSize,
          textSize: list.textSize,
          deleted: list.deleted,
          position: index + 1,
          type: list.type
        })

      })
      this.listMarketData = data;
    },
    async deleteField(index, type) {

      //delete from formularData
      if (type === 'formular') {
        this.formularData[index].deleted = true;
      } else if (type === 'header') {
        this.headerData[index].deleted = true;
      } else if (type === 'list') {
        this.listData[index].deleted = true;
      } else if (type === 'listMarket') {
        this.listMarketData[index].deleted = true;
      }

    },

    updateFunction() {
      this.getFormular();
      this.getProductCustomFields();
      this.getProductFormHeader();
      this.getProductFormList();
      this.getProductFormListMarket();
      this.getFormularName();
    },
    async saveFormField() {
      this.editHeader();
      this.editList();
      this.editListMarket();
      let saveData = [];
      let groupId = 0;

      let formDataCopy = [...this.formularData];
      
      formDataCopy.forEach((field, index) => {
        saveData.push({
          id: field.id,
          groupID: field.formularType === 'group' ? 0 : groupId,
          label: field.label,
          position: index + 1,
          field: (typeof field.field === 'undefined' || field.field === null) ? "" : field.field,
          formularType: field.formularType,
          readOnly: field.readOnly,
          formularId: this.formFieldId,
          deleted: field.deleted,
          value: field.value,
        });
        if (field.formularType === 'group' && field.deleted === false) {
          groupId = field.id;
        }
      });

      const attribute = {
        magazineTypeId: this.magazineType,
        formularName: this.name,
        formularId: this.formFieldId
      }

      const mutation = gql`
        mutation editFromField($forms: [FormInputs]!, $header: [FormHeaderInput]!, $lists: [FormListInput]!, $listsMarket: [FormListMarketInput]!, $attribute: AttributeInput) {
          editFromField(forms: $forms, header: $header, lists: $lists, listsMarket: $listsMarket, attribute: $attribute) {
            success
          }
        }
      `;

      try {
        const variables = {
          forms: saveData,
          header: this.headerData,
          lists: this.listData,
          listsMarket: this.listMarketData,
          attribute: attribute
        };
        const {data} = await apolloClient.mutate({mutation, variables});

        if (data.editFromField.success) {
          eventBus.openModal(SuccessConfirmation);
          eventBus.setData({
            title: "Formular gespeichert",
            message: "Das Formular wurde gespeichert.",
          });
          this.updateFunction();
          SignalBus.emit("sidebar-update-formular-name");
          SignalBus.emit("sidebar-update-formular-name");
        } else {
          console.error("Fehler beim Speichern des Formulars");
        }

      } catch (error) {
        console.error("Daten konnten nicht geUpdatet werden ", error);
      }
    },
    async deleteFormular() {
      const mutation = gql`
        mutation deleteFormular($formularID: Int! ) {
          deleteFormular(formularID: $formularID ) {
            success
          }
        }
      `;

      try {
        const variables = {
          formularID: this.formFieldId,
        };
        const {data} = await apolloClient.mutate({mutation, variables});
        if (data.deleteFormular.success) {
          eventBus.openModal(SuccessConfirmation);
          eventBus.setData({
            title: "Formular gelöscht",
            message: "Das Formular wurde gelöscht.",
          });
          router.push(`/administration/${this.accordionIndex}`);
        }

      } catch (error) {
        console.error(error);
      }
    },
    createNewField(type) {
      if (type === "formular") {

        const groups = this.formularData.filter(field => field.formularType === 'group');
        const lastGroupId = groups[groups.length - 1]?.id;

        this.formularData.push({
          id: 0,
          groupID: lastGroupId,
          formularType: 'input',
          label: "Neues Feld",
          value: "",
          readOnly: false,
          field: "",
          formularId: this.formFieldId,
          deleted: false,
          position: this.formularData.length + 1
        })
        this.$nextTick(() => {
          // Index des neu erstellten Feldes (am Ende des Arrays):
          const newIndex = this.formularData.length - 1;

          // Anhand deines data-ui-Attributes kannst du das neue Element identifizieren:
          const newFieldElement = document.querySelector(`[data-ui="move-field-${newIndex}"]`);

          if (newFieldElement) {
            // Smooth Scroll zum neu erstellten Feld:
            newFieldElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        });
      }
      if (type === 'header') {
        this.headerData.push({
          idProductFormHeader: 0,
          idProductForm: this.formFieldId,
          label: 'Neues Feld',
          field: '',
          size: '100',
          deleted: false,
          position: this.headerData.length + 1,
        })
      }
      if (type === 'list') {
        this.listData.push({
          idProductFormList: 0,
          idProductForm: this.formFieldId,
          label: 'Neues Feld',
          field: '',
          size: '100',
          deleted: false,
          position: this.listData.length + 1,
          type: 'text'
        })
      }
      if (type === 'listMarket') {
        this.listMarketData.push({
          idProductFormListMarket: 0,
          idProductForm: this.formFieldId,
          label: 'Neues Feld',
          field: '',
          mainSize: this.listMarketMainSize,
          textSize: '100',
          deleted: false,
          position: this.listMarketData.length + 1,
          listMarketType: 'text',
          type: 'input'
        })
      }
    },
    goBack() {
      router.push(`/administration`);
    },
    async getFormular() {
      try {
        const response = await apolloClient.query({
          query: gql`
            query  getFormular($formularID: Int!) {
              getFormular(formularID: $formularID) {
                id
                groupID
                formularType
                label
                value
                image
                readOnly
                field
              }
            }
          `,
          variables: {
            formularID: this.formFieldId
          }
        });

        try {
          let data = response.data.getFormular;
          if (data === null) {
            this.formularData = [];
          } else {
            data.forEach((item) => {
              item.deleted = false;
            })
            this.formularData = data;
          }

        } catch (error) {
          console.error(error);
        }

      } catch (error) {
        console.error("Fehler beim Abrufen der getFormularInfos:", error);
      }
    },
  },
  mounted() {
    this.getMagazineTypes();
    this.getFormularName();
    this.getProductFormList();
    this.getProductFormListMarket();
  },
  watch: {
    listMarketMainSize(newValue, oldValue) {
      if (newValue > 500) {
        this.listMarketMainSize = 500; // Setze den Wert auf 500, wenn er größer ist
      }
    },
    '$route.params.formId': function (newId, oldId) {
      this.formFieldId = newId;
      this.updateFunction();
    },


  },
  created() {
    if (this.$route.params.formId != null && typeof this.$route.params.formId != 'undefined' && this.$route.params.formId != '') {
      this.formFieldId = this.$route.params.formId;
      this.updateFunction();
    }
    this.accordionIndex =  this.$route.params.accordionIndex;

  }
}

</script>

